import monacoThemes from 'monaco-themes/themes/themelist';
import React from 'react';
import Select from 'react-select';

const ThemeDropdown = ({ handleThemeChange, theme }) => {
	return (
		<Select
			placeholder={`Select Theme`}
			// options={languageOptions}
			options={Object.entries(monacoThemes).map(([themeId, themeName]) => ({
				label: themeName,
				value: themeId,
				key: themeId,
			}))}
			value={theme}
			styles={{
				control: (provided, state) => ({
					...provided,
					width: 150,
					border: '1px solid #224c84',
					boxShadow: null,
					'&:hover': {
						border: '1px solid #224c84',
					},
				}),
			}}
			onChange={handleThemeChange}
		/>
	);
};

export default ThemeDropdown;
